var scope_0 = require('/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5b8f0e5a122fa45a964ef6390533941c.js').default;export default
        Object.assign({}, scope_0 )
    